module.exports = __webpack_public_path__ + "img/account.f0ca10cc.svg";